import React from 'react';
import logo from '../assets/images/Logo.png'

function Header(){
    return(
        <div className="header">
            <div className="header-content">
                <div className="logo">
                    <img src={logo} alt="logo"></img>
                    <a href="/#"><span>IRINA</span></a>
                </div>
                <div className="nav">
                    <ul>
                        <li><a href="/#about">ABOUT US</a></li>
                        <li><a href="/#mission">MISSIONS</a></li>
                        <li><a href="/#socmed">SOCMED</a></li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default Header